<div class="gpd-inner-page " style="height: 100% !important; padding: 0px !important;">
    <div class="gt-flex-dir-row-rev gt-padding-small-bottom"
        [style]="'width:100% !important; justify-content:space-between;'">
        <!-- <dx-text-box [value]="searchValue" [showClearButton]="true" i18n-placeholder="@@search ..." width="17vw"
            height="36px" placeholder="Search ..." valueChangeEvent="keyup" class="gpd-input"
            (onValueChanged)="search($event)" [mode]="'search'">
        </dx-text-box> -->

    </div>
    <div #wikimainscrollableDiv style="overflow-y: auto;">
        <div class="form-style gt-flex-dir-col scroll-min-width padding wiki-container-inner">
            <div *ngFor="let article of articles, let i = index" class="wiki-article">
                <div class="gt-flex-dir-row ">
                    <div *ngIf="article.headers.length !==0" class="article-title-expander"
                        (click)="article.childrenVisible = article.childrenVisible === true ? false:true;">
                        <i *ngIf="article.childrenVisible!==true" class="dx-icon dx-icon-chevronnext"></i>
                        <i *ngIf="article.childrenVisible===true" class="dx-icon dx-icon-chevrondown"></i>
                    </div>
                    <div *ngIf="article.headers.length ==0" class="article-title-expander blank">
                        <i class="dx-icon dx-icon-isblank"></i>
                    </div>

                    <div class="gt-flex-dir-col wiki-article-container">
                        <a [routerLink]="article.id" class="article-title level-0" [innerHTML]="article.articleTitle"
                            (click)="setBreadCrumb()"> </a>
                        <ul *ngIf="article.childrenVisible" class="article-child-container level-1">
                            <div [ngTemplateOutlet]="articleChild"
                                [ngTemplateOutletContext]="{parent: article, level: 1, article: article}">
                            </div>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #articleChild let-parent="parent" let-level="level" let-article="article">
    <li *ngFor="let child of parent?.headers">
        <a class="article-sub-title" [routerLink]=" article.id+'/'+child.tagId" class="article-title level-{{level}}"
            [innerHTML]="child.title">
        </a>

        <ul class="article-child-container level-{{level+1}}">
            <div [ngTemplateOutlet]="articleChild"
                [ngTemplateOutletContext]="{parent: child, level: level+1, article: article}">
            </div>
        </ul>
    </li>
</ng-template>